const BaseView = require('./view');

module.exports = BaseView.extend({
    containerClasses: 'odf-row',
    paxRowClasses: 'odf-space-inner-top-m odf-space-inner-bottom-m',
});
